import useAxios from '../../hooks/useAxios'
import useBrand from '../../hooks/useBrand'
import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { HrefLang } from './Hreflang'

export default function useHreflangs(pathname: string | undefined): HrefLang[] {
  const brand = useBrand()
  const axios = useAxios()
  const { data } = useQuery({
    enabled: !!brand.site_id,
    refetchOnWindowFocus: false,
    queryKey: ['hreflangs', brand.site_id, pathname],
    queryFn: async (): Promise<HrefLang[]> => {
      const { data } = await axios.get(
        `/api/v2/sites/${brand.site_id}/hreflang?urlPath=${pathname}`
      )
      return data
    },
  })

  const hreflangs = useMemo(() => (data instanceof Array ? data : []), [data])

  return hreflangs
}
